import React from "react";
import { ImgBox, TextBox, Wrapper } from "./style";
const Com1 = () => {
  return (
    <Wrapper>
      <TextBox>
        <span>Support</span>
        <span>도움이 필요한 서비스를 선택 또는 검색해 주세요.</span>
      </TextBox>
      <ImgBox loading="lazy">
        <img loading="lazy" src="/assets/img/Support_1.svg" alt="" />
      </ImgBox>
    </Wrapper>
  );
};

export default Com1;
